// Package imports
// Helpers
import bobtailAPI from './axiosConfig'

const CLIENT_PATH_URL = '/api/clients/search'
const DEBTOR_PATH_URL = '/api/debtors/search'

const clientSearch = async (string, hitsPerPage = 25, params = { page: 0 }) => {
  return (await bobtailAPI()).get(CLIENT_PATH_URL, {
    params: {
      query: string,
      hitsPerPage,
      ...params,
    },
  })
}

// Only used in base-debtor-search
const debtorSearch = async (string, page = 1, includeNotFoundDebtor = true) => {
  return (await bobtailAPI()).get(
    `${DEBTOR_PATH_URL}?hitsPerPage=5&query=${string}&page=${page}${
      includeNotFoundDebtor
        ? '&includeNotFoundDebtor=true'
        : ''
    }`
  )
}

export default {
  clientSearch,
  debtorSearch,
}
